import { render, staticRenderFns } from "./UploadsTable.vue?vue&type=template&id=25f7161c&"
import script from "./UploadsTable.vue?vue&type=script&lang=js&"
export * from "./UploadsTable.vue?vue&type=script&lang=js&"
import style0 from "./UploadsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard})
